import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer, NodeViewWrapper, NodeViewProps } from "@tiptap/react";
import CtaBlockRenderer from "../CtaBlockRenderer";

function CtaBlockNodeView({ node }: NodeViewProps) {
  // Extract text from node content
  const content = node.content;
  let text = "Secure early access to Fedgroup Private Markets";
  
  if (content && content.size > 0) {
    const textParts: string[] = [];
    content.forEach((child) => {
      if (child.text) {
        textParts.push(child.text);
      }
    });
    if (textParts.length > 0) {
      text = textParts.join("");
    }
  }

  return (
    <NodeViewWrapper className="cta-block-wrapper my-8" data-type="cta-block">
      <CtaBlockRenderer text={text} />
    </NodeViewWrapper>
  );
}

export interface CtaBlockNodeOptions {
  HTMLAttributes: Record<string, any>;
}

export const CtaBlockNode = Node.create<CtaBlockNodeOptions>({
  name: "ctaBlock",

  group: "block",

  atom: false,

  content: "inline*",

  selectable: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      class: {
        default: "cta-block",
        parseHTML: (element) => element.getAttribute("data-class") || "cta-block",
        renderHTML: (attributes) => {
          return { "data-class": attributes.class };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-type='cta-block']",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, {
        "data-type": "cta-block",
        "data-class": HTMLAttributes.class,
        class: "cta-block",
      }),
      0,
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CtaBlockNodeView);
  },
});

export default CtaBlockNode;
